// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discount-badge[data-v-65e090be]{position:absolute;top:-8px;padding:.2rem}.discount-badge-del-price[data-v-65e090be]{position:absolute;top:-4px;margin-left:2px;padding:.33rem}", ""]);
// Exports
module.exports = exports;
